import { apiClient } from '@/lib/api/client'
import type { DashboardSummary } from '@/types'

export interface DashboardSummaryParams {
  year?: number
  month?: number
}

export const getDashboardSummary = async (params?: DashboardSummaryParams): Promise<DashboardSummary> => {
  const { data } = await apiClient.get('/api/dashboard/summary/', { params })
  return data
}

